module.exports = __webpack_public_path__ + "img/chevron-up.e7b3f208.svg";